const STATE_NAME_BY_ABBREVIATION = {
  AL: "Alabama",
  AK: "Alaska",
  AZ: "Arizona",
  AR: "Arkansas",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DE: "Delaware",
  FL: "Florida",
  GA: "Georgia",
  HI: "Hawaii",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  IA: "Iowa",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  ME: "Maine",
  MD: "Maryland",
  MA: "Massachusetts",
  MI: "Michigan",
  MN: "Minnesota",
  MS: "Mississippi",
  MO: "Missouri",
  MT: "Montana",
  NE: "Nebraska",
  NV: "Nevada",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NY: "New York",
  NC: "North Carolina",
  ND: "North Dakota",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PA: "Pennsylvania",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VT: "Vermont",
  VA: "Virginia",
  WA: "Washington",
  WV: "West Virginia",
  WI: "Wisconsin",
  WY: "Wyoming",
  DC: "District of Columbia",
};

const toLookupKey = (value) =>
  `${value || ""}`
    .trim()
    .toLowerCase()
    .replace(/[^a-z]/g, "");

const STATE_LOOKUP = new Map();

Object.entries(STATE_NAME_BY_ABBREVIATION).forEach(([abbreviation, stateName]) => {
  STATE_LOOKUP.set(toLookupKey(abbreviation), abbreviation);
  STATE_LOOKUP.set(toLookupKey(stateName), abbreviation);
});

STATE_LOOKUP.set(toLookupKey("Washington DC"), "DC");
STATE_LOOKUP.set(toLookupKey("Washington D.C."), "DC");
STATE_LOOKUP.set(toLookupKey("D.C."), "DC");

export const normalizeStateToAbbreviation = (value) => {
  const raw = `${value || ""}`.trim();
  if (!raw) {
    return "";
  }

  const match = STATE_LOOKUP.get(toLookupKey(raw));
  if (match) {
    return match;
  }

  return raw.toUpperCase();
};

export const US_STATE_ABBREVIATIONS = Object.keys(STATE_NAME_BY_ABBREVIATION);
